import React, { createContext, useState, useContext, useEffect } from 'react';

// Location context for managing location-based features
const LocationContext = createContext();

export const LocationProvider = ({ children }) => {
  const [isIndia, setIsIndia] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    // Detect user's location using various methods
    const detectLocation = async () => {
      try {
        // Method 1: Use browser's timezone to detect India
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const isIndianTimezone = timezone && (
          timezone.includes('Kolkata') || 
          timezone.includes('Calcutta') ||
          timezone.includes('Asia/Kolkata')
        );
        
        // Method 2: Use browser language
        const browserLang = navigator.language || navigator.userLanguage;
        const isIndianLang = browserLang && (
          browserLang.includes('hi') || 
          browserLang.includes('en-IN') ||
          browserLang.includes('ta') ||
          browserLang.includes('te') ||
          browserLang.includes('mr') ||
          browserLang.includes('bn')
        );
        
        // Method 3: Check if using INR currency preference
        const savedCurrency = localStorage.getItem('preferredCurrency');
        const isINRCurrency = savedCurrency === 'INR';
        
        // If any strong indicator shows India, set as India
        if (isIndianTimezone || isIndianLang || isINRCurrency) {
          setIsIndia(true);
          setIsLoading(false);
          return;
        }
        
        // Method 4: IP-based geolocation (most accurate but requires API call)
        try {
          const response = await fetch('https://ipapi.co/json/');
          const data = await response.json();
          if (data.country_code === 'IN') {
            setIsIndia(true);
          } else {
            setIsIndia(false);
          }
        } catch (geoError) {
          // If geolocation fails, use the earlier detection
          setIsIndia(isIndianTimezone || isIndianLang);
        }
      } catch (error) {
        console.error('Error detecting location:', error);
        setIsIndia(false); // Default to non-India
      } finally {
        setIsLoading(false);
      }
    };
    
    detectLocation();
  }, []);
  
  const value = {
    isIndia,
    isLoading
  };
  
  return (
    <LocationContext.Provider value={value}>
      {children}
    </LocationContext.Provider>
  );
};

// Custom hook to use location context
export const useLocation = () => {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error('useLocation must be used within a LocationProvider');
  }
  return context;
};